var map = {
	"./Dr-soft — full.png": "b403",
	"./altegio.png": "0d1f",
	"./archimed.png": "5f83",
	"./arnicaV2.png": "ce301",
	"./cloud1C.png": "251d",
	"./dentalPro.png": "b6d6",
	"./dikidi.png": "a1ac",
	"./klientix.png": "73d9",
	"./medesk.png": "3056",
	"./profSalonBat.png": "d6e2",
	"./sonline.png": "1e76",
	"./sycret.png": "d712",
	"./universeSoft.png": "5716",
	"./waitThai.png": "1310f",
	"./yClients.png": "8315"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c01";